import $ from 'jquery';
import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';

Swiper.use([Navigation]);

let swiper = null;
function initPreloginSwiper()
{
    const slider = document.querySelector('.prelogin-swiper');
    swiper = new Swiper(slider, {
        slidesPerView: 3,
        loop: false,
        spaceBetween: 80,
        navigation: {
            nextEl: '.prelogin-swiper-button-next',
            prevEl: '.prelogin-swiper-button-prev',
        },
        on: {
            init: function () {
                $('#prelogin-slider-content').removeClass('not-visible');
            }
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            720: {
                slidesPerView: 2
            },
            1280: {
                slidesPerView: 3
            }
        },
    });
}

window.loadSliderElementsByType = function (type) {
    setTimeout(function () {
        if (swiper) {
            swiper.destroy(true, true);
        }
        let dataUrl = '/prelogin-slider/' + type;
        $.ajax({
            url: dataUrl,
            type: 'POST',
            data: {},
            cache: false,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            processData: true,
            success: function (response) {
                $('#prelogin-slider-content').html(response.template);
                initPreloginSwiper();
            },
            error: function (response) {
            }
        });
    }, 200);
}

$('.prelogin-category-btn').on('click', function () {
    $('#prelogin-slider-content').addClass('not-visible');

    const that = this;
    setTimeout(function () {
        if (swiper) {
            swiper.destroy(true, true);
        }
        $('.prelogin-category-btn').removeClass('is-active');
        $(that).addClass('is-active');
        let dataUrl = $(that).data('url');
        $.ajax({
            url: dataUrl,
            type: 'POST',
            data: {},
            cache: false,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            processData: true,
            success: function (response) {
                $('#prelogin-slider-content').html(response.template);
                initPreloginSwiper();
            },
            error: function (response) {
            }
        });
    }, 200);
})

//initialize first slider
if (document.querySelector('.prelogin-category-btn.is-active')) {
    let element = document.querySelector('.prelogin-category-btn.is-active');
    element.click();
}
